<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="w1200 career_details">
			<div class="career_details_cont">
				<div class="career_details_top cl_dark f26px">
					<img :src="data.assess_project_data.pic" class="mar10" />
					<span>{{data.assess_project_data.name}}</span>
				</div>
				<div class="career_details_btm flex mat20">
					<div class="f16px cl_dark">
						<div v-if="data.assess_project_data.intro != ''">简介：{{data.assess_project_data.intro}}</div>
						<div class="mat10" v-if="data.assess_project_data.use_intro != ''">说明：{{data.assess_project_data.use_intro}}</div>
					</div>
					<router-link :to="{ path: '/career_test', query: { id: data.assess_project_data.id,name: data.assess_project_data.name}}" class="career_details_start radius20 cl_white f18px tc">开始评测</router-link>
				</div>
			</div>
			<div class="career_history mat50" v-if="data.user_assess_project_log_data.length > 0">
				<table>
					<thead>
						<tr class="f18px">
							<th>评测项目</th>
							<th>评测日期</th>
							<th>评测状态</th>
						</tr>
					</thead>
					<tbody class="f16px">
						<tr v-for="(item,index) in data.user_assess_project_log_data" :key="index">
							<td align="center">{{data.assess_project_data.name}}</td>
							<td align="center" class="cl_dark">{{item.done_time}}</td>
							<td align="center"><router-link :to="{path: '/career_report', query: {id: item.id}}" class="cl_blue">查看报告</router-link></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'career_details',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 0,
				data: {
					assess_project_data: {},
					user_assess_project_log_data: [],
				},
				id: "",
			}
		},
		mounted() {
			this.id = this.$route.query.id;
			this.getdetails();
		},
		methods: {
			getdetails () {
				this.$get("/api/assess/get_assess_project_show",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					this.data = res.data;
				});
			},
			
		},
	}
</script>

<style>
</style>
